import React from "react";

function FbIconSvg() {
  return (
    <svg
      width={33}
      height={34}
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5.76C7.387.76 0 8.084 0 17.116c0 8.1 5.949 14.81 13.748 16.108V20.527h-3.98v-4.57h3.98V12.59c0-3.91 2.409-6.04 5.928-6.04 1.685 0 3.133.125 3.554.18v4.086l-2.44.001c-1.914 0-2.283.901-2.283 2.223v2.917h4.565l-.595 4.569h-3.97v12.808C26.671 32.348 33 25.468 33 17.11 33 8.083 25.613.76 16.5.76z"
        fill="#264445"
      />
    </svg>
  );
}

export default FbIconSvg;
